// Peças pequenas partilhadas pelo modo 2D (navegador de vistas, barras
// de ferramentas e rodapé). Ficaram fora do `Views2DSurface` para o
// ficheiro do modo ficar só com estado e layout. A formatação está no
// `format.ts` ao lado (regra do react-refresh).

export function Section({
  title,
  children,
}: {
  title: string
  children: React.ReactNode
}) {
  return (
    <div className="rounded border border-[var(--color-border-subtle)] p-1.5">
      <div className="mb-1 px-1 text-[9px] uppercase tracking-wider text-[var(--color-text-muted)]">
        {title}
      </div>
      {children}
    </div>
  )
}

export function IconBtn({
  label,
  title,
  onClick,
  danger,
}: {
  label: string
  title: string
  onClick: () => void
  danger?: boolean
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      title={title}
      aria-label={title}
      className={`shrink-0 rounded px-1 text-[10px] text-[var(--color-text-dim)] hover:bg-[var(--color-bg)] ${
        danger ? 'hover:text-red-400' : 'hover:text-[var(--color-text)]'
      }`}
    >
      {label}
    </button>
  )
}

export function NumberField({
  label,
  value,
  onChange,
  step = 1,
  min,
  compact,
  disabled,
  title,
}: {
  label: string
  value: number
  onChange: (v: number) => void
  step?: number
  min?: number
  compact?: boolean
  disabled?: boolean
  title?: string
}) {
  return (
    <label
      className={`flex items-center gap-1 ${compact ? '' : 'justify-between'}`}
      title={title}
    >
      <span className="shrink-0 text-[10px] text-[var(--color-text-muted)]">
        {label}
      </span>
      <input
        type="number"
        value={Number.isFinite(value) ? value : 0}
        step={step}
        min={min}
        disabled={disabled}
        onChange={(e) => {
          const n = Number(e.target.value)
          if (Number.isFinite(n)) onChange(n)
        }}
        className={`rounded border border-[var(--color-border)] bg-[var(--color-bg)] px-1 py-0.5 text-[11px] outline-none focus:border-[var(--color-accent)] disabled:opacity-40 ${
          compact ? 'w-[68px]' : 'w-[84px]'
        }`}
      />
    </label>
  )
}
